module.exports = {
	home: {
		bindAccountTitle: '綁定账号',
		getNameTitle: '设置账号名',
		linkAccountTitle: '关联账号',
		yinjicode: '引继码',
		changePsw: '设置/修改密码',
		cancelAccountTitle: '删除游客账号',
		// loginDeviceTitle: '登录设备管理',
		bindAccountBtn: '绑定FUNDOLL账号',
		accountTitle: '账号',
		checkAccountBtn: '切换账号',
		changePswTitle: '修改密码',
		clickPswTitle: '點擊修改',
		binded: '已綁定',
		goChangeBind: '前往换綁',
		goBind: '前往綁定',
		emailBindTitle: '綁定邮箱',
		privacyTitls: '隐私政策',
		FAQTitle: '常见问题',
		kefu: '客服',
		logOffTitle: '注销账号',
		accountTitle1: '账号名',
		accountIdTitle: '账号ID',
		changeEmailBtn: '换绑邮箱',
		touristName: '游客用户',
		touristTitle: '已认证',
		logOut: '登出',
		setNameTitle: '请输入您想要设置的账号名',
		bindAccountsTips: '注：绑定的账号下不能存在其他游戏角色。',
		gotoBindBtn: '前往绑定',
		query: '自助查询中心',
	},
	toast: {
		verifycodeBtn: '获取',
		verifycodeBtn2: '重新获得',
		comfirmBtn1: '确定',
		comfirmBtn2: '取消',
		emailPlaceholder: '请输入邮箱',
		setNamePlaceholder: '请输入账号名',
		setNameTitls: '由7-16位字母、数字组成，必须存在一位字母',
		verifyTitle: '请输入验证码',
		pswTitle1: '请输入新密碼',
		pswTitle2: '请再次确认输入新密码',
		comfirmPswTips: '两次輸入的密碼需要相同',
		verifypswTips: '密码长度为6-18位非中文/空格字元',
		newverifypswTips: '请输入密码',
		verifyemailTips: '格式错误无法识别，请重新输入',
		noEmail: '请输入要綁定的邮箱',
		longTime: '停留页面时间太长，请重新验证',
		noInfo: '暂未收集到信息',
		binded: '您的账号已被绑定。如有疑问，请联系客服查询',
		banCancelAccount: '不能解绑当前授权登录的{name}账号',
		noEmail1: '请输入邮箱',
		logout1: '设备登出操作成功',
	},
	logoff: {
		logoffTipsText1:
			'1.在您提交账号注销申请次日起的15日内，我们将处理您的注销申请，若您在15日届满前重新登录该游戏账号，则注销申请将被自动撤销。',
		logoffTipsText2: '2.账号注销成功后，您将永久无法使用该游戏账号。',
		logoffTipsText3:
			'3.如果您有任何疑问，请在工作时间（周一到周日，10:00-19:00）联系客服咨询。',
		logoffTipsBtn: '确认注销',
		text1: '为了保障您的账号安全',
		text2: '您的账号注销申请提交成功!',
		text11: '您的账号注销成功!',
		text3: `您已于{time}成功提交账号注销申请，现您的账号处于注销流程中。`,
		text4: `您的账号将于{time}注销，在此前您登录该通行证账号，您账号的注销流程将自动撤销。`,
		text5: '提示',
		text9: '区服',
		text7: '角色',
		text8: '等级',
		text10: '请仔细阅读注销须知',
		text6: '确认删除后，您的游客账号将会被重置为全新账号，当前的游戏记录将无法找回。请谨慎操作。',
		tourText2: '游戏',
		tourText3: '游戏角色',
		tourText4: '游戏UID',
		tourText5: '游戏等级',
		logoffScuessTips: '您已申请注销账号，登录状态失效',
		agreementTips: '我已详细阅读并同意{name}',
		buttonText: '前往阅读协议',
		buttonText1: '前往注销',
	},
	title: {
		title: '个人中心',
		title1: '隐私政策',
		title2: '常见问题',
		title3: '客服',
		title4: '安全验证',
		title5: '绑定账号',
		title6: '绑定邮箱',
		title7: '修改密码',
		title8: '注销须知',
		title9: '账号注销提醒',
		title10: '设置账号名',
		title11: '解绑账号',
		title12: '关联账号',
		// title13: '注销须知',
		title14: '注销确认',
		title15: '账号注销提醒',
		title16: '登录设备管理',
		title18: '换绑邮箱',
		title19: '账号名设置',
		netError: '网络出错无法进行操作，请检查网络连接',
		title20: '注销协议',
		title21: '隐私政策',
		title22: '用户协议',

		title23: '引继码',
		title24: '绑定引继码',
		title25: '查看引继码',
	},
	verifyText: {
		titleTxt1:
			'为了保护您的账号安全，设置新的账号名前，请先验证账号绑定的邮箱',
		titleTxt2: '为了保护您的账号安全，关联新账号前，请先验证账号绑定的邮箱',
		titleTxt3: '为了保护您的账号安全，修改密码前，请先验证账号绑定的邮箱',
		titleTxt4:
			'为了保护您的账号安全，进行设备管理前，请先验证账号绑定的邮箱',
		titleTxt5:
			'为了保护您的账号安全，换绑邮箱前，请先验证账号目前绑定的邮箱',
		titleTxt6: '为了保护您的账号安全，解除绑定前，请先验证账号绑定的邮箱',
		title1: '邮箱',
	},
	successText: {
		goBack: '返回',
		successTitle1: '绑定成功',
		successTitle2: '解绑成功',
		successTitle3: '换绑邮箱成功',
		successTitle4: '设置成功',
	},
	bindAccountText: {
		text1: '解绑',
		text2: '绑定',
		text3: '已有账号',
		text4: '注册并绑定',
		text5: '为了保护您的账号安全，绑定账号前，请先验证账号绑定的邮箱',
		text6: '绑定FUNDOLL账号',
		text7: '请输入通行证账号/邮箱/账号名',
		text8: '您的账号已被绑定。如有疑问，请联系客服查询',
	},
	preamble: {
		tx1: '在本台设备上使用引继码后，该设备登录的游戏记录将会被清除，替换为该引继码的游戏记录，之前设备将无法使用该引继码的游戏记录。',
		tx2: '使用引继码',
		tx3: '在其他设备上使用引继码后，您将能在其他设备上继承您的游戏记录，同时本台设备的游戏记录将会被清除。',
		tx4: '查看引继码',
		tx5: '请输入您想要使用的引继码',
		tx6: '引继码密码',
		tx7: '(如未设置过引继码密码可不填写该项内容)',
		tx8: '请输入该引继码的密码',
		tx9: '与当前设备的引继码相同，不可使用',
		tx10: '暂无游戏角色',
		tx11: '点击“确定使用”后，之前的设备将不能登录该游戏角色。',
		tx12: '确定使用',
		tx13: '使用成功',
		tx14: '(一旦设置引继码密码便不能更改)',
		tx15: '复制',
		tx16: '密码设置成功！',
		tx17: '复制成功！',
		tx18: '复制失败，请手动选择复制！',
	},
};
